import React, { useEffect, useState } from 'react';

import { TmCreditCardType } from '@/tscapi/model/account';

export const cardTypeName = (creditCardType) => {
    switch (creditCardType) {
        case TmCreditCardType.Visa:
            return 'Visa';
        case TmCreditCardType.MasterCard:
            return 'Mastercard';
        case TmCreditCardType.Amex:
            return 'Amex';
        case TmCreditCardType.TSC:
            return 'TSC Card';
        default:
            return 'Visa';
    }
};

export const getLogoByCreditCardType = (creditCardType) => {
    switch (creditCardType) {
        case TmCreditCardType.Visa:
            //These 4 need to be modified
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 220.8 141.8"
                    height="30"
                    className="paymentmethod__card-svg tagCCImageVisa"
                >
                    <path fill="#231F20" d="M0 0h220.8v141.8H0z" />
                    <g fill="#FFF">
                        <path d="M7.1 6.8h206.8v18.4H7.1zM7.1 116.5h206.8v18.4H7.1zM89.9 45.6L68.5 96.3H54.6L44 55.8c-.6-2.5-1.2-3.4-3.1-4.5a56.6 56.6 0 0 0-13-4.3l.3-1.5h22.4c2.9 0 5.4 1.9 6.1 5.2L62.3 80 76 45.6h13.9zm54.6 34.1c.1-13.4-18.6-14.1-18.5-20.1 0-1.8 1.8-3.8 5.6-4.2 1.9-.2 7.1-.4 13 2.3l2.3-10.8a37.1 37.1 0 0 0-12.3-2.2c-13 0-22.2 6.9-22.3 16.8-.1 7.3 6.6 11.4 11.5 13.8 5.1 2.5 6.9 4.1 6.8 6.3 0 3.4-4.1 4.9-7.9 5-6.6.1-10.5-1.8-13.5-3.2l-2.4 11.1c3.1 1.4 8.8 2.6 14.7 2.7 13.9-.1 22.9-6.9 23-17.5m34.4 16.6h12.2l-10.7-50.7h-11.2a6 6 0 0 0-5.6 3.7l-19.8 47h13.8l2.7-7.6h16.9l1.7 7.6zm-14.7-18l6.9-19 4 19h-10.9zm-55.5-32.7L97.8 96.3H84.6l10.9-50.7h13.2z" />
                    </g>
                    <path fill="#FFF" d="M220.8 0H0v141.8h220.8M218.9 139.9H2.1V1.9h216.8v138z" />
                </svg>
            );
        case TmCreditCardType.MasterCard:
            return (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220.8 141.8" height="30" className="tagCCImageMC">
                    <path fill="#231F20" d="M0 0h220.8v141.8H0z" />
                    <path
                        fill="#FFF"
                        d="M68.7 124.5v-7.1c0-2.7-1.7-4.5-4.4-4.5-1.4 0-2.9.4-4 2a4 4 0 0 0-3.7-2c-1.2 0-2.4.4-3.3 1.7v-1.4h-2.5v11.3h2.5v-6.3c0-2 1.1-3 2.8-3 1.6 0 2.5 1.1 2.5 3v6.3h2.5v-6.3c0-2 1.1-3 2.8-3 1.7 0 2.5 1.1 2.5 3v6.3h2.3zm36.7-11.3h-4v-3.4h-2.5v3.4h-2.3v2.2h2.3v5.2c0 2.6 1 4.2 3.9 4.2 1.1 0 2.3-.3 3.1-.9l-.7-2.1c-.7.4-1.5.6-2.2.6-1.2 0-1.6-.8-1.6-1.9v-5.1h4v-2.2zm21-.2c-1.4 0-2.3.7-3 1.7v-1.4H121v11.3h2.5v-6.3c0-1.9.8-2.9 2.4-2.9l1.5.3.8-2.3c-.6-.4-1.3-.4-1.8-.4zm-31.7 1.1c-1.4-.8-3-1.3-4.6-1.2-2.9 0-4.7 1.4-4.7 3.6 0 1.8 1.4 3 3.9 3.3l1.2.2c1.3.2 2 .5 2 1.2 0 .9-.9 1.4-2.6 1.4-1.4 0-2.7-.4-3.8-1.2l-1.2 1.9c1.4 1 3.1 1.6 4.9 1.5 3.3 0 5.2-1.5 5.2-3.7 0-2-1.5-3-3.9-3.4l-1.2-.2c-1.1-.1-1.9-.4-1.9-1.1 0-.8.8-1.3 2.2-1.3 1.4 0 2.8.5 3.5 1l1-2zm65.8-1.1c-1.4 0-2.3.7-3 1.7v-1.4h-2.4v11.3h2.5v-6.3c0-1.9.8-2.9 2.4-2.9l1.5.3.8-2.3c-.6-.4-1.3-.4-1.8-.4zm-31.6 5.9c0 3.4 2.4 5.9 6 5.9 1.7 0 2.8-.4 4.1-1.3l-1.2-2c-.9.7-1.9 1-3 1-2 0-3.4-1.4-3.4-3.6s1.4-3.6 3.4-3.6c1.1 0 2 .4 3 1l1.2-2a6 6 0 0 0-4.1-1.3c-3.6 0-6 2.5-6 5.9zm23 0v-5.6h-2.5v1.4c-.8-1-2-1.7-3.6-1.7-3.2 0-5.6 2.5-5.6 5.9 0 3.5 2.5 5.9 5.6 5.9 1.6 0 2.8-.6 3.6-1.7v1.4h2.5v-5.6zm-9.2 0c0-2 1.3-3.6 3.4-3.6 2 0 3.4 1.6 3.4 3.6 0 2.1-1.4 3.6-3.4 3.6-2.1 0-3.4-1.6-3.4-3.6zm-29.6-5.9c-3.3 0-5.6 2.4-5.6 5.9 0 3.6 2.4 5.9 5.8 5.9 1.7 0 3.3-.4 4.6-1.6l-1.2-1.8c-.9.8-2.2 1.2-3.3 1.2-1.6 0-3-.7-3.4-2.8h8.4v-.9c0-3.5-2.2-5.9-5.3-5.9zm-.1 2.2c1.6 0 2.6 1 2.9 2.7H110c.3-1.6 1.3-2.7 3-2.7zm61.7 3.7v-10.2h-2.5v5.9c-.8-1-2-1.7-3.6-1.7-3.2 0-5.6 2.5-5.6 5.9 0 3.5 2.5 5.9 5.6 5.9 1.6 0 2.8-.6 3.6-1.7v1.4h2.5v-5.5zm-9.2 0c0-2 1.3-3.6 3.4-3.6 2 0 3.4 1.6 3.4 3.6 0 2.1-1.4 3.6-3.4 3.6-2.1 0-3.4-1.6-3.4-3.6zm-82.9 0v-5.6h-2.5v1.4c-.8-1-2-1.7-3.6-1.7-3.2 0-5.6 2.5-5.6 5.9 0 3.5 2.5 5.9 5.6 5.9 1.6 0 2.8-.6 3.6-1.7v1.4h2.5v-5.6zm-9.2 0c0-2 1.3-3.6 3.4-3.6 2 0 3.4 1.6 3.4 3.6 0 2.1-1.4 3.6-3.4 3.6-2.1 0-3.4-1.6-3.4-3.6zm105.4 4l.4.1.4.2.2.4.1.4-.1.4-.2.4-.4.2-.4.1-.5-.1-.4-.2-.2-.4-.1-.4.1-.4.2-.4.4-.2.5-.1zm0 2l.3-.1.3-.2.2-.3.1-.3-.1-.3-.2-.3-.3-.2-.3-.1-.3.1-.3.2-.2.3-.1.3.1.3.2.3.3.2.3.1zm0-1.4l.3.1.1.2-.1.2-.2.1.3.4h-.2l-.3-.4h-.1v.4h-.2v-1h.4zm-.2.2v.3h.4l.1-.1-.1-.1-.4-.1zM177.3 87v-1.4h.6v-.3h-1.4v.3h.6V87h.2zm2.7 0v-1.7h-.4l-.5 1.1-.5-1.1h-.4V87h.3v-1.2l.5 1.1h.3l.5-1.1V87h.2zm-71.3 8.2l1 .9a42.4 42.4 0 1 1 0-70.8l-1 .9a45.9 45.9 0 0 0 0 69zm30.1-77.1c-8.4 0-16.5 2.4-23.5 7.1l1 .9a46 46 0 0 1 0 69.2l-1 .9a42.5 42.5 0 1 0 23.5-78.1zm-26.3 9.1l-1.6 1.3a42.3 42.3 0 0 0 0 64.2l1.6 1.3 1.6-1.3a42.3 42.3 0 0 0 0-64.2l-1.6-1.3"
                    />
                    <path fill="#FFF" d="M220.8 0H0v141.8h220.8M218.9 139.9H2.1V1.9h216.8v138z" />
                </svg>
            );
        case TmCreditCardType.Amex:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 220.8 141.8"
                    height="30"
                    className="paymentmethod__card-svg tagCCImageAmex"
                >
                    <path fill="#FFF" d="M0 0h220.8v141.8H0z" />
                    <path d="M138.8 108.4l-4.3-5.3v5.3h-14.2v-9.1c-1.8.8-3.8 1.3-6 1.3h-5v7.8H87.8l-3.9-5.1-3.9 5.1H44.4V74.5h35.8l3.9 5.1 3.9-5.1h130.3V1.9H2.4V49l8.1-19h14L29 40.6V30h17.5l2.7 7.7 2.7-7.7H130v3.9c2.8-2.5 6.7-3.9 11.2-3.9h24.9l4.5 10.6V30h14.7l3.9 6v-6h14.7v33.9h-14.6l-3.9-6.1v6.1H164l-2.1-5.2H156l-2.1 5.2h-13.3c-4.3 0-8-1.3-10.7-3.7v3.7H108l-4.3-5.3v5.3H22.4l-2.1-5.2h-5.9l-2.1 5.2h-10v75.9h215.9v-34c-2.2 1.6-5 2.5-8.2 2.5h-71.2v.1z" />
                    <path d="M199.6 59.7V34.2h-6.4V50L183 34.2h-8.2v25.4h6.5V43.3l10.5 16.4h7.8zm-32.7 0h7.3l-10.9-25.4h-8.4L144 59.7h7.1l2.1-5.2h11.6l2.1 5.2zM162.5 49h-7.1l3.5-8.7 3.6 8.7zm-20.8-8.9h6.8v-5.9h-7.3c-8 0-12.3 5.3-12.3 12.5v.4c0 7.8 4.5 12.5 11.8 12.5h.5l2.6-5.7h-2.1c-4.1 0-6.5-2.5-6.5-6.8v-.4c.1-3.7 2.3-6.6 6.5-6.6zm-22.4 19.6h6.5V34.2h-6.5v25.5zm-1 0l-8.2-9.3c4.2-.9 6.7-4 6.7-8 0-4.9-3.4-8.2-8.8-8.2H93.7v25.4h6.5v-9h2.5l7.6 9h8v.1zm-11.1-14.6h-7v-5.2h7c2 0 3 1.2 3 2.6 0 1.5-1 2.6-3 2.6zM69.3 59.7H90V54H75.8v-4.3h13.9v-5.6H75.8V40h14.3v-5.7H69.3v25.4zm-10.6 0H65V34.2H54.9l-5.7 16.2-5.7-16.2H33.2v25.4h6.4V40.9l6.7 18.8H52l6.7-18.8v18.8zm-33.4 0h7.3L21.7 34.2h-8.4L2.4 59.7h7.1l2.1-5.2h11.6l2.1 5.2zM20.9 49h-7.1l3.5-8.7 3.6 8.7zM215.9 84.4l2.5-5.7H205c-5.5 0-8.8 3.4-8.8 8 0 4.8 3.1 7.6 7.9 7.6h6c1.3 0 2.3.8 2.3 2.1s-1 2.1-2.3 2.1h-13.2v5.7H210c5.5 0 8.8-3.3 8.8-8.3 0-4.6-2.9-7.3-7.9-7.3h-6c-1.3 0-2.3-.8-2.3-2.1s1-2.1 2.3-2.1h11zm-36.6 2.1c0-1.3.9-2.1 2.3-2.1h11l2.5-5.7h-13.4c-5.5 0-8.8 3.4-8.8 8 0 4.8 3.1 7.6 7.9 7.6h6c1.3 0 2.3.8 2.3 2.1s-1 2.1-2.3 2.1h-13.2v5.7h13.1c5.5 0 8.8-3.3 8.8-8.3 0-4.6-2.9-7.3-7.9-7.3h-6c-1.3 0-2.3-.8-2.3-2.1zM150 104.1h20.7v-5.7h-14.3v-4.3h13.9v-5.6h-13.9v-4.1h14.3v-5.7H150v25.4zm-1 0l-8.2-9.3c4.2-.9 6.7-4 6.7-8 0-4.9-3.4-8.2-8.8-8.2h-14.1V104h6.5v-9h2.5l7.6 9h7.8v.1zm-11.1-14.5h-7v-5.2h7c2 0 3 1.2 3 2.6 0 1.5-1 2.6-3 2.6zm-16.2-2.3c0-5.1-3.4-8.6-8.8-8.6H98.6v25.4h6.5v-8.3h7.7c5.4.1 8.9-3.6 8.9-8.5zm-6.5 0c0 1.6-1 2.8-3 2.8H105v-5.7h7.2c2 0 3 1.3 3 2.9zM98 104.1L87.8 91.3 98 78.7h-8l-6 7.8-6-7.8h-8.1l10.2 12.8L70 104.1h7.9l6-7.9 6 7.9H98zm-49.3 0h20.7v-5.7H55.2v-4.3h13.9v-5.6H55.2v-4.1h14.3v-5.7H48.7v25.4z" />
                    <g>
                        <path fill="#FFF" d="M220.8 0H0v141.8h220.8M218.9 139.9H2.1V1.9h216.8v138z" />
                    </g>
                </svg>
            );
        case TmCreditCardType.TSC:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 76.4 73.4"
                    height="30"
                    className="creditcard__svg--tsc tagCCImageTSC"
                >
                    <path
                        fill="#211D1D"
                        d="M62 29.4c-4.1 0-7.6 3.6-7.6 7.8 0 4.3 3.5 7.9 7.6 7.9 2.4 0 4.6-1.2 6-3.1l4 3.5c.7-2.8 1-5.7 1-8.6 0-2.8-.3-5.5-.9-8.1L68 32.4c-1.4-1.8-3.6-3-6-3"
                    />
                    <path
                        fill="#211D1D"
                        d="M26.3 22.2v2.5c2.1-1.9 5.2-3 8.9-3 5.2 0 9.3 1.4 12.6 4.1l-4.2 6c-2.8-2-5.9-3-8.6-3-2.1 0-3.1.8-3.1 2 0 1.5 1 2 5.3 2.9 3.5.8 6.4 1.6 8.4 3 .3-8.2 7.7-15 16.4-15 3.2 0 6.2.9 8.7 2.5C65.6 10.2 52.2.4 36.5.4 21.6.4 8.7 9.4 3.1 22.2h23.2M62 52.8c-5.7 0-10.8-2.9-13.7-7.2-1.3 4.6-5.7 7.2-12 7.2-5.4 0-10.5-1.7-14.4-5.1l4.7-5.6c3.1 2.4 6.4 3.7 9.9 3.7 2.3 0 3.5-.8 3.5-2.1 0-1.4-1-1.7-5.2-2.6-6.5-1.5-11.6-3.2-11.6-9.5 0-.6.1-1.2.2-1.8h-6.1v22.5H8.9V29.8H.7a36.51 36.51 0 0 0 69.7 20.7C67.9 52 65 52.8 62 52.8m11.2-30.4h-.5v-.2H74v.2h-.5v1.4h-.2l-.1-1.4m1.1-.2h.2l.6 1.1.6-1.1h.3v1.7h-.2v-1.2l-.6 1.1-.6-1.1v1.2h-.2v-1.7"
                    />
                </svg>
            );
        default:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 220.8 141.8"
                    className="paymentmethod__card-svg tagCCImageVisa"
                >
                    <path fill="#231F20" d="M0-.3h221V142H0z" />
                    <g fill="#FFF">
                        <path d="M7.1 6.8h206.8v18.4H7.1zM7.1 116.5h206.8v18.4H7.1z" />
                        <path d="M221 1.9V-.2H0V142h221V1.9zm-2.1 138H2.1V1.9h216.8v138z" />
                        <path d="M89.9 45.6L68.5 96.3H54.6L44 55.8c-.6-2.5-1.2-3.4-3.1-4.5a56.6 56.6 0 0 0-13-4.3l.3-1.5h22.4c2.9 0 5.4 1.9 6.1 5.2L62.3 80 76 45.6h13.9zm54.6 34.1c.1-13.4-18.6-14.1-18.5-20.1 0-1.8 1.8-3.8 5.6-4.2 1.9-.2 7.1-.4 13 2.3l2.3-10.8a37.1 37.1 0 0 0-12.3-2.2c-13 0-22.2 6.9-22.3 16.8-.1 7.3 6.6 11.4 11.5 13.8 5.1 2.5 6.9 4.1 6.8 6.3 0 3.4-4.1 4.9-7.9 5-6.6.1-10.5-1.8-13.5-3.2l-2.4 11.1c3.1 1.4 8.8 2.6 14.7 2.7 13.9-.1 22.9-6.9 23-17.5m34.4 16.6h12.2l-10.7-50.7h-11.2a6 6 0 0 0-5.6 3.7l-19.8 47h13.8l2.7-7.6h16.9l1.7 7.6zm-14.7-18l6.9-19 4 19h-10.9zm-55.5-32.7L97.8 96.3H84.6l10.9-50.7h13.2z" />
                    </g>
                </svg>
            );
    }
};

export const getLogoByCreditCardTypeNew = (creditCardType) => {
    switch (creditCardType) {
        case TmCreditCardType.Visa:
            //These 4 need to be modified
            return (
                <img
                    src="/App_Assets/public/visa.svg"
                    width="24"
                    height="24"
                    alt="visa-icon"
                    className="tagCCImageVisa"
                ></img>
            );
        case TmCreditCardType.MasterCard:
            return (
                <img
                    src="/App_Assets/public/mastercard.svg"
                    alt="mastercard-icon"
                    width="30"
                    height="30"
                    style={{ maxWidth: '84px', width: '84px', marginTop: '-4px', marginLeft: '-21px' }}
                    className="tagCCImageMC"
                ></img>
            );
        case TmCreditCardType.Amex:
            return (
                <img
                    src="/App_Assets/public/amex.svg"
                    alt="amex-icon"
                    style={{ marginLeft: '-5px' }}
                    width="24"
                    height="24"
                    className="tagCCImageAmex"
                ></img>
            );
        case TmCreditCardType.TSC:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 76.4 73.4"
                    height="30"
                    className="creditcard__svg--tsc tagCCImageTSC"
                >
                    <path
                        fill="#211D1D"
                        d="M62 29.4c-4.1 0-7.6 3.6-7.6 7.8 0 4.3 3.5 7.9 7.6 7.9 2.4 0 4.6-1.2 6-3.1l4 3.5c.7-2.8 1-5.7 1-8.6 0-2.8-.3-5.5-.9-8.1L68 32.4c-1.4-1.8-3.6-3-6-3"
                    />
                    <path
                        fill="#211D1D"
                        d="M26.3 22.2v2.5c2.1-1.9 5.2-3 8.9-3 5.2 0 9.3 1.4 12.6 4.1l-4.2 6c-2.8-2-5.9-3-8.6-3-2.1 0-3.1.8-3.1 2 0 1.5 1 2 5.3 2.9 3.5.8 6.4 1.6 8.4 3 .3-8.2 7.7-15 16.4-15 3.2 0 6.2.9 8.7 2.5C65.6 10.2 52.2.4 36.5.4 21.6.4 8.7 9.4 3.1 22.2h23.2M62 52.8c-5.7 0-10.8-2.9-13.7-7.2-1.3 4.6-5.7 7.2-12 7.2-5.4 0-10.5-1.7-14.4-5.1l4.7-5.6c3.1 2.4 6.4 3.7 9.9 3.7 2.3 0 3.5-.8 3.5-2.1 0-1.4-1-1.7-5.2-2.6-6.5-1.5-11.6-3.2-11.6-9.5 0-.6.1-1.2.2-1.8h-6.1v22.5H8.9V29.8H.7a36.51 36.51 0 0 0 69.7 20.7C67.9 52 65 52.8 62 52.8m11.2-30.4h-.5v-.2H74v.2h-.5v1.4h-.2l-.1-1.4m1.1-.2h.2l.6 1.1.6-1.1h.3v1.7h-.2v-1.2l-.6 1.1-.6-1.1v1.2h-.2v-1.7"
                    />
                </svg>
            );
        default:
            return (
                <img
                    src="/App_Assets/public/visa.svg"
                    width="24"
                    height="24"
                    alt="visa-icon"
                    className="tagCCImageVisa"
                ></img>
            );
    }
};
